import { useState } from 'react';
import useUser from '../user/userController';

const useResetPasswordController = () => {
  const [validationNewPassword, setValidationNewPassword] =
    useState<boolean>(true);
  const [validationConfirmPassword, setValidationConfirmPassword] =
    useState<boolean>(true);
  const [validationCurrentPassword, setValidationCurrentPassword] =
    useState<boolean>(true);

  const [newPassword, setNewPassword] = useState<Password>('');
  const [confirmPassword, setConfirmPassword] = useState<Password>('');
  const [currentPassword, setCurrentPassword] = useState<Password>('');

  const handleCurrentPaswordInput = (newValue: string) => {
    setCurrentPassword(newValue);
  };
  const handleNewPasswordInput = (newValue: string) => {
    setNewPassword(newValue);
  };
  const handleConfirmPasswordInput = (newValue: string) => {
    setConfirmPassword(newValue);
  };

  const onValidateNewPassword = (value: boolean) => {
    setValidationNewPassword(!value);
  };
  const onValidateConfirmPassword = (value: boolean) => {
    setValidationConfirmPassword(!value);
  };
  const onValidateCurrentPassword = (value: boolean) => {
    setValidationCurrentPassword(!value);
  };

  const { tryChangePassword } = useUser();
  const onTryChangePassword = async () => {
    tryChangePassword({
      currentPassword,
      newPassword,
    });
    setNewPassword('');
    setCurrentPassword('');
    setConfirmPassword('');
  };

  return {
    handleCurrentPaswordInput,
    newPassword,
    confirmPassword,
    currentPassword,
    handleConfirmPasswordInput,
    handleNewPasswordInput,
    validationConfirmPassword,
    validationNewPassword,
    validationCurrentPassword,
    onValidateNewPassword,
    onValidateConfirmPassword,
    onValidateCurrentPassword,
    onTryChangePassword,
  };
};

export default useResetPasswordController;
